/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetUserPaymentMethods200ResponseAllOfData } from './GetUserPaymentMethods200ResponseAllOfData';
import {
    GetUserPaymentMethods200ResponseAllOfDataFromJSON,
    GetUserPaymentMethods200ResponseAllOfDataFromJSONTyped,
    GetUserPaymentMethods200ResponseAllOfDataToJSON,
} from './GetUserPaymentMethods200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetUserPaymentMethods200ResponseAllOf
 */
export interface GetUserPaymentMethods200ResponseAllOf {
    /**
     * 
     * @type {GetUserPaymentMethods200ResponseAllOfData}
     * @memberof GetUserPaymentMethods200ResponseAllOf
     */
    data: GetUserPaymentMethods200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetUserPaymentMethods200ResponseAllOf interface.
 */
export function instanceOfGetUserPaymentMethods200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetUserPaymentMethods200ResponseAllOfFromJSON(json: any): GetUserPaymentMethods200ResponseAllOf {
    return GetUserPaymentMethods200ResponseAllOfFromJSONTyped(json, false);
}

export function GetUserPaymentMethods200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserPaymentMethods200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetUserPaymentMethods200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetUserPaymentMethods200ResponseAllOfToJSON(value?: GetUserPaymentMethods200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetUserPaymentMethods200ResponseAllOfDataToJSON(value.data),
    };
}

